<template>
  <div>
    <AppBanner v-bind="$props">
      <template #primaryCta>
        <button
          class="btn btn-sm primary-cta"
          @click="ctaClicked"
        >
          {{ primaryCtaText }}
        </button>
      </template>
    </AppBanner>
    <TeamWizard
      v-if="showTeamWizard"
      @close="closeTeamWizard"
    />
  </div>
</template>

<script>
import AppBanner from '../AppBanner.vue';
import TeamWizard from './TeamWizard.vue';

export default {
  name: 'TeamsPromotionBanner',
  components: {
    AppBanner,
    TeamWizard,
  },
  extends: AppBanner,
  data: () => ({
    showTeamWizard: false,
  }),
  computed: {
    primaryCtaText() {
      return this.bannerProps.primaryCta.text;
    },
  },
  methods: {
    ctaClicked() {
      this.showTeamWizard = true;
      this.trackCtaClicked();
    },
    closeTeamWizard() {
      this.showTeamWizard = false;
    },
  },
};
</script>
